import Link from 'antd/es/typography/Link';
import styled from 'styled-components';

export const UserPageSidebarWrap = styled.aside`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  font-size: 16px;
  height: 100vh;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  background: linear-gradient(to top, var(--bg-leftmenu-panel-color), white);
`;
export const UserPageContentWrap = styled.div`
  flex: 1;
  display: flex;
  background-color: #edf4fd;
  overflow: auto;
  margin-left: 250px;
  flex-direction: column;
`;
export const UserName = styled.div`
  margin-top: 10px;
  padding-left: 10px;
  height: 100px;
  width: 220px;
  text-align: center;
`;
export const UserAction = styled.div`
  margin: 10px 0px;
  padding: 0px 0px 10px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 230px;
  background-color: #d7e8f5;
`;
export const EditUserLink = styled(Link)`
  font-weight: bold;
  padding-top: 8px;
`;
